import { render, staticRenderFns } from "./FreezeDetails.vue?vue&type=template&id=624ea914&scoped=true&"
import script from "./FreezeDetails.vue?vue&type=script&lang=js&"
export * from "./FreezeDetails.vue?vue&type=script&lang=js&"
import style0 from "./FreezeDetails.vue?vue&type=style&index=0&id=624ea914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624ea914",
  null
  
)

export default component.exports